class UserError extends Error {
/*  constructor(...args) {
    super(...args);
    Error.captureStackTrace(this, UserError);
  } */
}
class AccessForbidden extends Error {

}

class ServerError extends Error {

}

class SerialDuplicateError extends Error {

}

class UserExistsError extends Error {

}

class ImageNotFoundError extends Error {

}

class GroupHasReportsError extends Error {

}
export {
  UserError,
  UserExistsError,
  AccessForbidden,
  ServerError,
  SerialDuplicateError,
  ImageNotFoundError,
  GroupHasReportsError,
};
